export default __webpack_public_path__ + "static/media/dashboard-5.cadfd1bd.png";